export const defaultState = {
  showing: false,
};

export const SHOW_PROGRESS_BAR = 'SHOW_PROGRESS_BAR';
export const showProgressBar = notification => {
  return dispatch => {
    return dispatch({
      type: SHOW_PROGRESS_BAR,
      payload: true,
    });
  };
};

export const HIDE_PROGRESS_BAR = 'HIDE_PROGRESS_BAR';
export const hideProgressBar = () => {
  return {
    type: HIDE_PROGRESS_BAR,
    payload: false,
  };
};

export const actions = {
  hideProgressBar,
  showProgressBar,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case HIDE_PROGRESS_BAR:
      return { ...state, showing: action.payload };
    case SHOW_PROGRESS_BAR:
      return { ...state, showing: action.payload };
    default:
      return state;
  }
}
